import type { FC } from 'react';
import useModal from '~/components/modal/Modal';
import { Button } from '~/components/shared';
import styles from './ChannelPreviewDialog.module.css';


export const FlexiPakkenInfoDialog: FC = () => {
  const { close } = useModal();

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Slik fungerer dine valg</h3>
      <section className={styles.group}>
        <p>I FleksiPakken bestemmer du selv hva du vil ha. Du starter med det du velger nå, men ingenting er låst. Du kan endre når du vil.</p>
      </section>
      <section className={styles.group}>
        <p className={styles.groupTitle}>Endre når du vil:</p>
        <p>Du kan når som helst logge inn på Min side og endre fra HBO Max til Viaplay, eller gå over til ekstra TV-kanaler.</p>
      </section>
      <section className={styles.group}>
        <p className={styles.groupTitle}>Ingen ekstra kostnad:</p>
        <p>Det koster ingenting å endre mellom de inkluderte alternativene i pakken din på Min side.</p>
      </section>
      <section className={styles.group}>
        <p className={styles.groupTitle}>Klar til bruk med en gang:</p>
        <p>Når du gjør en endring, blir det nye innholdet ditt tilgjengelig i løpet av få minutter.</p>
      </section>
      <section className={styles.group}>
        <p className={styles.groupTitle}>Full oversikt:</p>
        <p>På Min side har du alltid kontroll over hva du har valgt og hva du kan endre til.</p>
      </section>

      <p className={styles.groupTitle}>Godt å vite: Du har alltid TV 2 Play Start og de 16 faste TV-kanalene dine inkludert, uansett hva du velger her.</p>

      <div className={styles.footer}>
        <Button type="secondary" onClick={close}>
          Skjønner!
        </Button>
      </div>
    </div>
  );
};
